// extracted by mini-css-extract-plugin
module.exports = {"listaTarefas":"Lista_listaTarefas__vhUoa"};